import React, { useEffect } from "react";
import { useEditor, SET_EDIT_FIELD } from "../../context/editor";
import { useTranslation } from "react-i18next";
function CancelButton({ removeChild, currentElement }) {
  const [editorState, editorDispatch] = useEditor();
  const { t } = useTranslation(["newEditor", "common"]);
  useEffect(() => {
    if (editorState.currentElement._id != currentElement) {
      removeChild();
    }
  }, [editorState.currentElement._id]);

  const handleCancel = () => {
    removeChild();
    editorDispatch({
      type: SET_EDIT_FIELD,
      data: false,
    });
  };

  return (
    <button
      className="EditorCancelButton"
      onClick={handleCancel}
      contentEditable={false}
      style={{ userSelect: "none" }}
    >
      {t("editorButtons.cancel")}
    </button>
  );
}

export default CancelButton;
